var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-6"},[_vm._v("Create coupon")]),_c('CouponsForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }